import Logger from '../logger/logger';
import ERRORS from '../errors/errorids';
import AppError from '../errors/apperror';
const log = Logger.get('refersion');

export const saveDesktopAppCompanyId = (companyId) => {
	try {
		return sessionStorage.setItem('isDesktopApp', companyId);
	} catch (err) {
		log.send(new AppError({
			message: 'saveDesktopAppCompanyId() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getDesktopAppCompanyId = () => {
	try {
		return sessionStorage.getItem('isDesktopApp');
	} catch (err) {
		log.send(new AppError({
			message: 'getDesktopAppCompanyId() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearDesktopAppCompanyId = () => {
	try {
		sessionStorage.removeItem('isDesktopApp');
	} catch (err) {
		log.send(new AppError({
			message: 'clearDesktopAppCompanyId() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveHideDiscountBannerFlag = () => {
	try {
		return sessionStorage.setItem('hideDiscountBannerTemporarily', true);
	} catch (err) {
		log.send(new AppError({
			message: 'saveHideDiscountBannerFlag() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const isDiscountBannerTemporarilyHidden = () => {
	try {
		return sessionStorage.getItem('hideDiscountBannerTemporarily');
	} catch (err) {
		log.send(new AppError({
			message: 'isDiscountBannerTemporarilyHidden() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveMagixDiscountCredentials = (email, serial) => {
	try {
		return sessionStorage.setItem('discountCredentials', JSON.stringify({e: window.btoa(email), s: window.btoa(serial)}));
	} catch (err) {
		log.send(new AppError({
			message: 'saveMagixDiscountCredentials() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getMagixDiscountCredentials = () => {
	try {
		const value = sessionStorage.getItem('discountCredentials');
		if (!value) return null;
		const parsedJSON = JSON.parse(value);
		return { email: window.atob(parsedJSON.e), serial: window.atob(parsedJSON.s)};
	} catch (err) {
		log.send(new AppError({
			message: 'getMagixDiscountCredentials() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearMagixDiscountCredentials = () => {
	try {
		sessionStorage.removeItem('discountCredentials');
	} catch (err) {
		log.send(new AppError({
			message: 'clearMagixDiscountCredentials() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getCheckoutPlan = () => {
	try {
		return sessionStorage.getItem('cbCheckoutPlan');
	} catch (err) {
		log.send(new AppError({
			message: 'getCheckoutPlan() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveCheckoutPlan = (id) => {
	try {
		return sessionStorage.setItem('cbCheckoutPlan', id);
	} catch (err) {
		log.send(new AppError({
			message: 'saveCheckoutPlan() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveCheckoutLang = (lang) => {
	try {
		return sessionStorage.setItem('checkoutLang', lang);
	} catch (err) {
		log.send(new AppError({
			message: 'saveCheckoutLang() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getIsFirstOrder = () => {
	try {
		return sessionStorage.getItem('isFirstOrder');
	} catch (err) {
		log.send(new AppError({
			message: 'getIsFirstOrder() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const setIsFirstOrder = (value) => {
	try {
		return sessionStorage.setItem('isFirstOrder', value);
	} catch (err) {
		log.send(new AppError({
			message: 'saveFirstOrder() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearFirstOrder = () => {
	try {
		return sessionStorage.removeItem('isFirstOrder');
	} catch (err) {
		log.send(new AppError({
			message: 'saveFirstOrder() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getInvitedUsers = () => {
	try {
		const savedValue = sessionStorage.getItem('invitedUsers');
		return savedValue && JSON.parse(savedValue);
	} catch (err) {
		log.send(new AppError({
			message: 'getInvitedUsers() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveInvitedUsers = (value) => {
	try {
		return sessionStorage.setItem('invitedUsers', JSON.stringify(value));
	} catch (err) {
		log.send(new AppError({
			message: 'saveFirstOrder() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearInvitedUsers = () => {
	try {
		return sessionStorage.removeItem('invitedUsers');
	} catch (err) {
		log.send(new AppError({
			message: 'clearInvitedUsers() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getInviteMessage = () => {
	try {
		return sessionStorage.getItem('inviteMessage');
	} catch (err) {
		log.send(new AppError({
			message: 'getInvitedUsers() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveInviteMessage = (value) => {
	try {
		return sessionStorage.setItem('inviteMessage', value);
	} catch (err) {
		log.send(new AppError({
			message: 'saveFirstOrder() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearInviteMessage = () => {
	try {
		return sessionStorage.removeItem('inviteMessage');
	} catch (err) {
		log.send(new AppError({
			message: 'clearInvitedUsers() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getCheckoutSeatsQuantity = () => {
	try {
		return sessionStorage.getItem('cbCheckoutSeatsQuantity');
	} catch (err) {
		log.send(new AppError({
			message: 'getCheckoutSeatsQuantity() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveCheckoutSeatsQuantity = (quantity) => {
	try {
		return sessionStorage.setItem('cbCheckoutSeatsQuantity', quantity);
	} catch (err) {
		log.send(new AppError({
			message: 'saveCheckoutSeatsQuantity() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getReUpgradePopupPlan = () => {
	try {
		return sessionStorage.getItem('ReUpgradePopupPlan');
	} catch (err) {
		log.send(new AppError({
			message: 'getReUpgradePopupPlan() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveReUpgradePopupPlan = (plan) => {
	try {
		return sessionStorage.setItem('ReUpgradePopupPlan', plan);
	} catch (err) {
		log.send(new AppError({
			message: 'saveReUpgradePopupPlan() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearReUpgradePopupPlan = () => {
	try {
		sessionStorage.removeItem('ReUpgradePopupPlan');
	} catch (err) {
		log.send(new AppError({
			message: 'clearReUpgradePopupPlan() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};


export const getIsReUpgradePopupFlag = () => {
	try {
		return sessionStorage.getItem('isReUpgradePopup');
	} catch (err) {
		log.send(new AppError({
			message: 'getIsReUpgradePopupFlag() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveIsReUpgradePopupFlag = (plan) => {
	try {
		return sessionStorage.setItem('isReUpgradePopup', plan);
	} catch (err) {
		log.send(new AppError({
			message: 'saveIsReUpgradePopupFlag() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearIsReUpgradePopupFlag = () => {
	try {
		sessionStorage.removeItem('isReUpgradePopup');
	} catch (err) {
		log.send(new AppError({
			message: 'clearIsReUpgradePopupFlag() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const getIsDesktopTrial = () => {
	try {
		return sessionStorage.getItem('isDesktopTrial');
	} catch (err) {
		log.send(new AppError({
			message: 'getIsDesktopTrial() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveIsDesktopTrial = (value) => {
	try {
		return sessionStorage.setItem('isDesktopTrial', value);
	} catch (err) {
		log.send(new AppError({
			message: 'saveIsDesktopTrial() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearIsDesktopTrial = () => {
	try {
		return sessionStorage.removeItem('isDesktopTrial');
	} catch (err) {
		log.send(new AppError({
			message: 'clearIsDesktopTrial() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};


export const getIsReAccessNoIndustry = () => {
	try {
		return sessionStorage.getItem('isReAccessNoIndustry');
	} catch (err) {
		log.send(new AppError({
			message: 'getIsReAccessNoIndustry() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const saveIsReAccessNoIndustry = (value) => {
	try {
		return sessionStorage.setItem('isReAccessNoIndustry', value);
	} catch (err) {
		log.send(new AppError({
			message: 'saveIsReAccessNoIndustry() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};

export const clearIsReAccessNoIndustry = () => {
	try {
		return sessionStorage.removeItem('isReAccessNoIndustry');
	} catch (err) {
		log.send(new AppError({
			message: 'clearIsReAccessNoIndustry() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
};





// WEBPACK FOOTER //
// ./src/utils/storage.js